import "./App.css"; // Make sure your CSS styles are in this file
import MapComponent from "./MapComponent";
import React from "react";
import ReactDOM from "react-dom";
import "leaflet/dist/leaflet.css";

// # Example 1: Simple "Hello, World" code
ReactDOM.render(
  <div className="App">
    <div className="map-container">
      <div
        class="elfsight-app-4bcd4d7c-f06d-4300-a882-b3bcf97ee82c"
        data-elfsight-app-lazy
      ></div>
    </div>
  </div>,
  document.getElementById("react-app")
);
